function getDisabledDataAttribute(disabled) {
  if (!disabled) {
    return;
  }
  return { ["data-disabled"]: "" };
}

export { getDisabledDataAttribute };
//# sourceMappingURL=data-attribute.mjs.map
